import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Instagram, Facebook, Send } from "lucide-react";
import { whatsappLink } from "@/lib/api";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24 border-t border-[#D8D4CC] bg-[#EFECE5]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <Logo className="w-10 h-10 text-[#1B3B36]" />
            <div>
              <div className="font-serif text-2xl text-[#1B3B36]">Iryaa Homes</div>
              <div className="overline text-[10px] mt-1">every thread, a story</div>
            </div>
          </div>
          <p className="mt-6 text-[15px] leading-relaxed text-[#4A4A4A] max-w-md font-light">
            A small atelier of weavers, carpenters and colourists — crafting slow,
            heirloom-worthy objects for the considered home. Each piece is signed by
            the hands that made it.
          </p>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Explore</div>
          <ul className="space-y-3 text-[14px]">
            <li>
              <Link to="/legacy/collections" className="link-underline">
                Collections
              </Link>
            </li>
            <li>
              <Link to="/legacy/designer" className="link-underline">
                Custom Studio
              </Link>
            </li>
            <li>
              <Link to="/legacy/gallery" className="link-underline">
                Gallery
              </Link>
            </li>
            <li>
              <Link to="/legacy/about" className="link-underline">
                Atelier
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-4">Support</div>
          <ul className="space-y-3 text-[14px]">
            <li>
              <Link to="/legacy/faqs" className="link-underline">
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/legacy/contact" className="link-underline">
                Contact
              </Link>
            </li>
            <li>
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noreferrer"
                className="link-underline"
                data-testid="footer-whatsapp-link"
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-4">Studio</div>
          <address className="not-italic text-[14px] leading-relaxed text-[#4A4A4A] font-light">
            Iryaa Atelier · Ground Floor
            <br />
            17, Lavelle Lane · Bengaluru 560 001
            <br />
            +91 89711 88977
            <br />
            hello@iryaahomes.com
          </address>
          <div className="mt-5 flex gap-3">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="w-9 h-9 border border-[#1B3B36] text-[#1B3B36] flex items-center justify-center hover:bg-[#1B3B36] hover:text-[#F9F8F6] transition-colors"
            >
              <Instagram size={16} />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="w-9 h-9 border border-[#1B3B36] text-[#1B3B36] flex items-center justify-center hover:bg-[#1B3B36] hover:text-[#F9F8F6] transition-colors"
            >
              <Facebook size={16} />
            </a>
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
              className="w-9 h-9 border border-[#1B3B36] text-[#1B3B36] flex items-center justify-center hover:bg-[#1B3B36] hover:text-[#F9F8F6] transition-colors"
            >
              <Send size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#D8D4CC]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-[12px] text-[#4A4A4A]">
          <div>© {new Date().getFullYear()} Iryaa Homes. Handmade in India.</div>
          <div className="tracking-wider uppercase text-[11px]">
            Woven slowly, on purpose.
          </div>
        </div>
      </div>
    </footer>
  );
}
